import { Alert } from "react-bootstrap";

import { WarningIcon } from "../../../../components/icons";

interface LowBallanceAlertProps {
  outOfCredits: boolean;
}

const LowBallanceAlert: React.FC<LowBallanceAlertProps> = ({
  outOfCredits,
}) => {
  return (
    <div className="billing-alert-container">
      <Alert variant="danger" className="billing-alert">
        {outOfCredits ? (
          <>
            <h6>
              <WarningIcon /> You&#39;re out of credits!
            </h6>
            The API requests are currently failing due to insufficient credits,
            causing a disruption to your application. Please recharge now to
            restore functionality.
          </>
        ) : (
          <>
            <h6>
              <WarningIcon /> Your credit balance is running low.
            </h6>
            Recharge now to avoid API requests being interrupted for your
            application. If your account does not have sufficient credits, the
            API requests will temporarily fail for your application until
            credits are purchased.
          </>
        )}
      </Alert>
    </div>
  );
};

export { LowBallanceAlert };
